// extracted by mini-css-extract-plugin
export default {"backToReturn":"backToReturn_backToReturn__5HA8H"};